module.exports = __webpack_public_path__ + "static/media/boat.095b2280.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/boat.png
// module id = 161
// module chunks = 0